module.exports = __webpack_public_path__ + "img/20180703_183101.c3a8f35e.jpeg";